import { render, staticRenderFns } from "./MerchantDialog.vue?vue&type=template&id=475df5a8&scoped=true"
import script from "./MerchantDialog.vue?vue&type=script&lang=js"
export * from "./MerchantDialog.vue?vue&type=script&lang=js"
import style0 from "./MerchantDialog.vue?vue&type=style&index=0&id=475df5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475df5a8",
  null
  
)

export default component.exports